module.exports = __webpack_public_path__ + "img/password-reset-email-sent.0a4aae99.webp";